const siteName = "WordPress Developer Blog";
const defaultDescription = "News and articles from the WordPress developer blog.";
const defaultImage = "https://developer.wordpress.org/news/wp-content/themes/wporg-news-2021/images/wp-logo-blue.png";

function stripHtml(value = "") {
  const element = document.createElement("div");
  element.innerHTML = value;
  return element.textContent || element.innerText || "";
}

function ensureMeta(selector, createElement) {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = createElement();
    document.head.appendChild(element);
  }

  return element;
}

function setMetaByName(name, content) {
  const element = ensureMeta(`meta[name="${name}"]`, () => {
    const meta = document.createElement("meta");
    meta.setAttribute("name", name);
    return meta;
  });

  element.setAttribute("content", content);
}

function setMetaByProperty(property, content) {
  const element = ensureMeta(`meta[property="${property}"]`, () => {
    const meta = document.createElement("meta");
    meta.setAttribute("property", property);
    return meta;
  });

  element.setAttribute("content", content);
}

function setCanonical(url) {
  const element = ensureMeta('link[rel="canonical"]', () => {
    const link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    return link;
  });

  element.setAttribute("href", url);
}

export function getPlainText(html, maxLength) {
  const text = stripHtml(html).replace(/\s+/g, " ").trim();

  if (!maxLength || text.length <= maxLength) {
    return text;
  }

  return `${text.slice(0, maxLength - 3).trim()}...`;
}

export function updateSeo({
  title,
  description = defaultDescription,
  canonical = window.location.href,
  image = defaultImage,
  type = "website",
  publishedTime,
}) {
  const fullTitle = title === siteName ? title : `${title} | ${siteName}`;

  document.documentElement.setAttribute("lang", "it");
  document.title = fullTitle;

  setMetaByName("description", description);
  setCanonical(canonical);

  setMetaByProperty("og:site_name", siteName);
  setMetaByProperty("og:title", fullTitle);
  setMetaByProperty("og:description", description);
  setMetaByProperty("og:type", type);
  setMetaByProperty("og:url", canonical);
  setMetaByProperty("og:image", image);

  if (publishedTime) {
    setMetaByProperty("article:published_time", publishedTime);
  }

  setMetaByName("twitter:card", "summary_large_image");
  setMetaByName("twitter:title", fullTitle);
  setMetaByName("twitter:description", description);
  setMetaByName("twitter:image", image);
}
